import React from "react";
import { Descriptions, List } from "antd";
import { Icon } from "@ant-design/compatible";
import { WarehouseCardList } from "../../interface";
import { Link } from "react-router-dom";

const RowItem = (props: WarehouseCardList) => {
  return (
    <div className="rowItemWare">
      {" "}
      <Descriptions>
        <Descriptions.Item className="statusNum">
          {" "}
          <span className="row">
            <p>{props.itemName}</p>
            {props.email ? <p className="mailSell">{props.email}</p> : null}
          </span>{" "}
          <div className="staNum">
            {" "}
            <span className="status">{props.status}</span>
            <span className="numberType">{props.numPro}</span>
            <Descriptions.Item>
              {" "}
              <Link to={props.url}>
                <Icon
                  type="right "
                  style={{ fontSize: "16px", color: "#08c" }}
                  theme="outlined"
                />{" "}
              </Link>
            </Descriptions.Item>{" "}
          </div>
        </Descriptions.Item>
      </Descriptions>{" "}
    </div>
  );
};

export default RowItem;
